import React from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { brand } from '../mock';

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-28 pb-16 overflow-hidden"
      style={{
        background:
          'radial-gradient(1200px 600px at 80% 10%, rgba(212,175,55,0.10), transparent 60%), radial-gradient(800px 500px at 10% 90%, rgba(168,132,44,0.08), transparent 60%), linear-gradient(180deg, #faf7f0 0%, #f1ead8 100%)',
      }}
    >
      {/* Decorative sacred geometry - left */}
      <svg className="absolute -left-24 top-20 opacity-[0.07] floaty" width="520" height="520" viewBox="0 0 200 200" fill="none">
        <circle cx="100" cy="100" r="90" stroke="#a8842c" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="70" stroke="#a8842c" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="50" stroke="#a8842c" strokeWidth="0.5" />
      </svg>
      {/* Decorative sacred geometry - right */}
      <svg className="absolute -right-32 top-10 opacity-[0.08] floaty" width="640" height="640" viewBox="0 0 200 200" fill="none">
        <circle cx="100" cy="100" r="90" stroke="#a8842c" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="70" stroke="#a8842c" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="50" stroke="#a8842c" strokeWidth="0.5" />
        {Array.from({ length: 12 }).map((_, i) => (
          <line
            key={`line-${i * 15}`}
            x1="100"
            y1="10"
            x2="100"
            y2="190"
            stroke="#a8842c"
            strokeWidth="0.4"
            transform={`rotate(${i * 15} 100 100)`}
          />
        ))}
      </svg>

      <div className="absolute left-0 top-1/3 w-px h-40 bg-gradient-to-b from-transparent via-[#c9a961] to-transparent opacity-50" />
      <div className="absolute right-0 bottom-1/3 w-px h-40 bg-gradient-to-b from-transparent via-[#c9a961] to-transparent opacity-50" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-10 w-full text-center">
        <h1 className="font-display text-[36px] sm:text-6xl md:text-7xl lg:text-[88px] leading-[1.05] text-[#1a1714]">
          Discover your
          <br />
          <span className="italic font-cormorant">power numbers</span>
          <br />
          <span className="gold-text">decode your destiny.</span>
        </h1>

        <p className="mt-7 max-w-2xl mx-auto text-[15px] md:text-base leading-relaxed text-[#4a4035] font-light">
          Personal numerology readings, name corrections, and life‑path guidance.
          A quiet, classy, deeply intentional practice by
          <span className="text-[#1a1714] font-medium"> {brand.practitioner}</span>.
        </p>

        <div className="mt-8 sm:mt-10 flex flex-wrap justify-center gap-3 sm:gap-4">
          <a href="#reading" className="btn-gold">
            <Phone size={14} /> Book a Reading
          </a>
          <a href="#calculators" className="btn-outline-gold">
            Try the Calculator
          </a>
        </div>
      </div>

      <a
        href="#services"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#a8842c] flex flex-col items-center gap-2"
      >
        <span className="text-[10px] tracking-[0.35em] uppercase">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
